export default () => ({
  container: { display: 'flex', flexWrap: 'wrap' },
  chip: { marginRight: '4px', marginTop: '4px' }
});
